import { Link } from "react-router-dom";
import { Modal } from 'react-bootstrap';
import React, { useEffect, useState } from 'react';
import { get } from "../_services/apiService";
import { API_URL } from "../_services/apiUrl";
import Layout from "./Shared/Layout";
import { Helmet } from "react-helmet";

const imageurl = process.env.REACT_APP_IMAGE_BASE_URL

const Blog = () => {
    const [showModal, setShowModal] = useState(false);
    const [blogData, setBlogData] = useState([]);
    const [activeIndex, setActiveIndex] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState();

    const getShortDescription = (description, wordLimit) => {
        if (!description) return '';
        const text = description.replace(/<\/?[^>]+(>|$)/g, "").trim();
        const words = text.split(/\s+/);
        return words.length > wordLimit
            ? words.slice(0, wordLimit).join(' ') + '...'
            : words.join(' ');
    };


    const handleModalToggle = (index) => {
        setActiveIndex(index);
        setShowModal(!showModal);
    };

    const fetchBlogDetail = async () => {
        setLoading(true);
        try {
            const response = await get(API_URL.GetBlogDetail);
            if (response.isSuccess === 1 && response?.data !== null) {
                setBlogData(response?.data);
            } else {
                setError('Blog Not Avaiable');
            }
        } catch (error) {
            setError('Blog Not Avaiable');
        } finally {
            setLoading(false);
        }
    };

    const formatDate = (date) => {
        if (!date) return '';
        const d = new Date(date);
        const day = d.getDate().toString().padStart(2, '0');
        const month = (d.getMonth() + 1).toString().padStart(2, '0');
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };

    useEffect(() => {
        fetchBlogDetail();
    }, []);

    if (loading) return <div className="loading_content"><img src="./images/loading.gif" alt="Hand-stitched embroidered kurta – Gailee" /></div>;

    return (
        <Layout>
            <Helmet>
                {/* Title Tag */}
                <title>Gailee Blog – Styling Tips & Festive Ethnic Fashion Trends</title>
                {/* Meta Description */}
                <meta
                    name="description"
                    content="Explore ethnic styling tips, care guides, and seasonal outfit inspiration on the Gailee blog. Stay updated on new arrivals and how to wear them."
                />
                {/* Meta Robots Tag */}
                <meta name="robots" content="index, follow" />
                {/* Open Graph Tags */}
                <meta property="og:title" content="Gailee Blog – Styling Tips & Festive Ethnic Fashion Trends" />
                <meta property="og:description" content="Explore ethnic styling tips, care guides, and seasonal outfit inspiration on the Gailee blog. Stay updated on new arrivals and how to wear them." />
                {/* Structured Data (Schema.org) */}
                <script type="application/ld+json">{`
            {
              "@context": "https://schema.org",
              "@type": "Blog",
              "name": "Gailee Blog",
              "description": "Explore ethnic styling tips, care guides, and seasonal outfit inspiration on the Gailee blog. Stay updated on new arrivals and how to wear them."
            }
            `}</script>
            </Helmet>
            <section className="blog_main layout_main">
                <div className="container">
                    {/* H1 tag for SEO only, not visible on page */}
                    <h1 style={{ display: "none" }}>
                        Welcome to the Gailee Blog – Where Fashion Meets Heritage
                    </h1>
                    <div className="page-header mb-3">
                        <h1>My Blog</h1>
                    </div>
                    {error ? (
                        <div className="container search_page_not_data">
                            <div className="error_image row justify-content-center">
                                <img src="./images/error1.png" alt="Hand-stitched embroidered kurta – Gailee" className="col-lg-5 col-md-6 col-10" />
                            </div>
                        </div>
                    ) : (
                        <section className="blog_wepper_main d-flex justify-content-center mt-4">
                            <div className="row w-100">
                                {blogData.map((item, index) => (
                                    <div className="col-md-4 col-sm-6 col-12" key={index}>
                                        <div className="blog_wepper">
                                            <div className="blog_img_data">
                                                <img src={`${imageurl}${item?.blogImage}`} alt="Hand-stitched embroidered kurta – Gailee" />
                                            </div>
                                            <div className="blog_text_weper">
                                                <span>{formatDate(item?.blogDate)}</span>
                                                <h3>{item?.blogTitle}</h3>
                                                <p>{getShortDescription(item?.blogDescrption, 15)}</p>
                                                <Link to="#" onClick={() => handleModalToggle(index)} title="About Gailee – Learn about our brand">Read More</Link>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </section>
                    )}
                </div>

                {/* Modal */}
                {activeIndex !== null && (
                    <Modal
                        show={showModal}
                        onHide={() => setShowModal(false)}
                        dialogClassName="modal-xl"
                        centered
                        className="blog_popup"
                    >
                        <Modal.Header closeButton>
                            <Modal.Title>{blogData[activeIndex]?.blogTitle}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="popup_content">
                                <img
                                    src={`${imageurl}${blogData[activeIndex]?.blogImage}`}
                                    alt="Hand-stitched embroidered kurta – Gailee"
                                    className="popup_image "
                                /><br />
                                <span className="blog_popup_date">{formatDate(blogData[activeIndex]?.blogDate)}</span>
                                <div className="description-box">
                                    <div
                                        className="word-wrap"
                                        dangerouslySetInnerHTML={{ __html: blogData[activeIndex]?.blogDescrption }}
                                    />
                                </div>
                            </div>
                        </Modal.Body>
                    </Modal>
                )}
            </section>
        </Layout >
    );
};

export default Blog;
